import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const rhapsodyApi = createApi({
  reducerPath: "rhapsodyApi",
  baseQuery: (args, api) => baseQuery(args, api, { service: "rhapsody" }),
  endpoints: () => ({}),
  tagTypes: ["eventStatuses", "noteTypes", "sectionRoles"],
});
